import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.entity.reviews');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { EntityApi } from "src/libs/portal/review/entity";

@Component({
    selector: 'wiz-page-entity-reviews',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.entity.reviews/view.scss */
:host {
  --creation-canvas: var(--ro-canvas, #fafbf8);
  --creation-surface: #ffffff;
  --creation-surface-muted: #f9faf7;
  --creation-ink: #242821;
  --creation-muted: #6f756c;
  --creation-subtle: #969c93;
  --creation-line: #dfe3db;
  --creation-line-strong: #ccd3c8;
  --creation-orange: #df5934;
  --creation-orange-dark: #bd4325;
  --creation-orange-soft: #fff1eb;
  --creation-olive: #667d3e;
  --creation-olive-soft: #eff4e8;
  --creation-green: #2e745d;
  --creation-green-soft: #eaf4f0;
  --creation-violet: #655781;
  --creation-violet-soft: #f0edf6;
  display: block;
  min-height: 100%;
  color: var(--creation-ink);
  font-family: Pretendard, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

button,
input {
  font: inherit;
}

button {
  border: 0;
}

.creation-page {
  min-height: 100%;
  overflow-x: hidden;
  background: var(--creation-canvas);
}

.creation-shell {
  width: min(100% - 48px, 1480px);
  margin-inline: auto;
}

.creation-header {
  background: rgba(255, 255, 255, 0.96);
  border-bottom: 1px solid var(--creation-line);
}

.creation-heading {
  min-width: 0;
}

.creation-eyebrow {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  color: var(--creation-orange);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.14em;
}

.creation-eyebrow i {
  font-size: 12px;
}

.creation-heading h1 {
  margin: 10px 0 0;
}

.creation-heading > p:last-child {
  margin: 10px 0 0;
  color: var(--creation-muted);
  font-size: 12px;
  line-height: 1.6;
}

.creation-header__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
}

.creation-utility,
.creation-primary,
.row-action button,
.project-card > button,
.project-empty button,
.project-ledger__footer button,
.modal-cancel,
.modal-submit,
.project-created-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: none !important;
  cursor: pointer;
  transition: color 160ms ease, background-color 160ms ease, border-color 160ms ease, transform 160ms ease;
}

.creation-utility {
  min-height: 40px;
  gap: 8px;
  padding: 0 13px;
  color: #5f675e;
  background: #fff;
  border: 1px solid var(--creation-line);
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
}

.creation-utility:hover {
  color: var(--creation-ink);
  background: var(--creation-surface-muted);
  border-color: var(--creation-line-strong);
}

.creation-primary {
  min-height: 46px;
  gap: 9px;
  margin-left: 8px;
  padding: 0 18px;
  color: #fff;
  background: var(--creation-orange);
  box-shadow: 0 8px 18px rgba(181, 65, 34, 0.14) !important;
}

.creation-primary:hover {
  background: var(--creation-orange-dark);
  transform: translateY(-1px);
}

.creation-primary i {
  font-size: 12px;
}

.creation-overview {
  display: grid;
  grid-template-columns: minmax(250px, 1.35fr) repeat(3, minmax(170px, 1fr));
  overflow: hidden;
  background: var(--creation-surface);
  border: 1px solid var(--creation-line);
  border-radius: 13px;
  box-shadow: 0 5px 18px rgba(45, 54, 43, 0.04);
}

.creation-overview > article {
  min-width: 0;
  min-height: 118px;
  padding: 22px 24px;
}

.creation-overview > article + article {
  border-left: 1px solid var(--creation-line);
}

.creation-overview__intro {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #30352f;
}

.creation-overview__intro > span {
  color: #bfc7bb;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.creation-overview__intro strong {
  margin-top: 7px;
  color: #fff;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.03em;
}

.creation-overview__intro p {
  max-width: 340px;
  margin: 7px 0 0;
  color: #c9cec6;
  font-size: 12px;
  line-height: 1.55;
}

.creation-metric {
  display: flex;
  align-items: center;
  gap: 14px;
}

.creation-metric__icon {
  display: grid;
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  place-items: center;
  border-radius: 11px;
  font-size: 15px;
}

.creation-metric__icon.is-orange {
  color: #bd4a29;
  background: var(--creation-orange-soft);
}

.creation-metric__icon.is-violet {
  color: var(--creation-violet);
  background: var(--creation-violet-soft);
}

.creation-metric__icon.is-green {
  color: var(--creation-green);
  background: var(--creation-green-soft);
}

.creation-metric div {
  min-width: 0;
}

.creation-metric small,
.creation-metric strong,
.creation-metric p {
  display: block;
}

.creation-metric small {
  color: var(--creation-muted);
  font-size: 12px;
  font-weight: 700;
}

.creation-metric strong {
  margin-top: 3px;
  color: var(--creation-ink);
  font-size: 25px;
  line-height: 1;
  font-weight: 700;
  letter-spacing: -0.04em;
}

.creation-metric p {
  margin: 7px 0 0;
  overflow: hidden;
  color: var(--creation-subtle);
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.creation-path {
  display: grid;
  grid-template-columns: minmax(250px, 0.85fr) minmax(0, 2.5fr);
  align-items: stretch;
  overflow: hidden;
  background: var(--creation-surface);
  border: 1px solid var(--creation-line);
  border-radius: 13px;
  box-shadow: 0 5px 18px rgba(45, 54, 43, 0.035);
}

.creation-path__header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 22px 24px;
  background: var(--creation-surface-muted);
  border-right: 1px solid var(--creation-line);
}

.creation-path__header span,
.project-ledger__title span {
  color: var(--creation-orange);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.12em;
}

.creation-path__header h2 {
  margin: 6px 0 0;
  color: var(--creation-ink);
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.025em;
}

.creation-path__header > p {
  margin: 8px 0 0;
  color: var(--creation-muted);
  font-size: 12px;
  line-height: 1.55;
}

.creation-path__steps {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin: 0;
  padding: 0;
  list-style: none;
}

.creation-path__steps li {
  position: relative;
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr);
  grid-template-rows: auto auto;
  align-content: center;
  column-gap: 11px;
  min-width: 0;
  padding: 20px 17px;
}

.creation-path__steps li + li {
  border-left: 1px solid #ecefe9;
}

.creation-path__number {
  position: absolute;
  top: 12px;
  right: 12px;
  color: #c5cac2;
  font-size: 12px;
  font-weight: 700;
}

.creation-path__steps li > i {
  display: grid;
  width: 34px;
  height: 34px;
  grid-row: 1/3;
  place-items: center;
  color: var(--creation-olive);
  background: var(--creation-olive-soft);
  border-radius: 9px;
  font-size: 12px;
}

.creation-path__steps strong {
  align-self: end;
  color: #343a33;
  font-size: 12px;
  font-weight: 700;
}

.creation-path__steps p {
  align-self: start;
  margin: 4px 0 0;
  color: var(--creation-subtle);
  font-size: 12px;
  line-height: 1.45;
}

.project-ledger {
  background: var(--creation-surface);
  border: 1px solid var(--creation-line);
}

.project-ledger__title {
  display: grid;
  grid-template-columns: auto auto;
  align-items: end;
  gap: 0 10px;
}

.project-ledger__title > div {
  min-width: 0;
}

.project-ledger__title h2 {
  margin: 5px 0 0;
  color: var(--creation-ink);
  font-size: 19px;
  font-weight: 700;
  letter-spacing: -0.03em;
}

.project-ledger__title > strong {
  align-self: end;
  margin-bottom: 2px;
  padding: 4px 7px;
  color: var(--creation-olive);
  background: var(--creation-olive-soft);
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}

.project-ledger__title > p {
  grid-column: 1/-1;
  margin: 7px 0 0;
  color: var(--creation-muted);
  font-size: 12px;
}

.project-search {
  color: var(--creation-muted);
  background: #fff;
  border: 1px solid var(--creation-line-strong);
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.project-search:focus-within {
  border-color: #83976a;
}

.project-search > i {
  font-size: 12px;
}

.project-search input {
  min-width: 0;
  flex: 1;
  padding: 0;
  color: var(--creation-ink);
  box-shadow: none !important;
  font-size: 12px;
  font-weight: 600;
}

.project-search input::placeholder {
  color: #a1a69e;
}

.project-search button {
  display: grid;
  width: 26px;
  height: 26px;
  place-items: center;
  color: var(--creation-muted);
  background: #f1f3ef;
  cursor: pointer;
}

.project-filter-tabs {
  background: var(--creation-surface-muted);
  border-top: 1px solid #ecefe9;
  border-bottom: 1px solid var(--creation-line);
  scrollbar-width: thin;
}

.project-filter-tabs button {
  display: inline-flex;
  min-height: 34px;
  align-items: center;
  gap: 7px;
  flex: 0 0 auto;
  padding: 0 11px;
  color: #747b72;
  background: transparent;
  border: 1px solid transparent;
  cursor: pointer;
  transition: color 160ms ease, background-color 160ms ease, border-color 160ms ease;
}

.project-filter-tabs button strong {
  display: grid;
  min-width: 20px;
  height: 20px;
  place-items: center;
  padding: 0 5px;
  color: #858c83;
  background: #ecefe9;
}

.project-filter-tabs button:hover {
  color: var(--creation-ink);
  background: #fff;
  border-color: var(--creation-line);
}

.project-filter-tabs button.is-active {
  color: var(--creation-orange-dark);
  background: #fff;
  border-color: #efb49f;
}

.project-filter-tabs button.is-active strong {
  color: #fff;
  background: var(--creation-orange);
}

.project-ledger__table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

.project-ledger__table thead {
  background: #fff;
  border-bottom: 1px solid var(--creation-line);
}

.project-ledger__table th {
  height: 48px;
  padding: 0 13px;
  color: #858b83;
  font-size: 12px;
  font-weight: 700;
  text-align: left;
  letter-spacing: 0.015em;
}

.project-ledger__table th:first-child,
.project-ledger__table td:first-child {
  padding-left: 24px;
}

.project-ledger__table th:last-child,
.project-ledger__table td:last-child {
  padding-right: 24px;
}

.project-ledger__table th:nth-child(1) {
  width: 19%;
}

.project-ledger__table th:nth-child(2) {
  width: 11%;
}

.project-ledger__table th:nth-child(3) {
  width: 16%;
}

.project-ledger__table th:nth-child(4) {
  width: 18%;
}

.project-ledger__table th:nth-child(5) {
  width: 11%;
}

.project-ledger__table th:nth-child(6) {
  width: 12%;
}

.project-ledger__table th:nth-child(7) {
  width: 13%;
}

.project-ledger__table tbody tr {
  height: 126px;
  background: #fff;
  border-bottom: 1px solid #e8ebe5;
  animation: row-in 0.24s ease both;
  transition: background-color 160ms ease, box-shadow 160ms ease;
}

.project-ledger__table tbody tr:hover {
  background: #fbfcf9;
  box-shadow: inset 3px 0 0 var(--creation-orange);
}

.project-ledger__table tbody tr:last-child {
  border-bottom: 0;
}

.project-ledger__table td {
  padding: 17px 13px;
  vertical-align: middle;
}

.project-cell {
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr);
  align-items: center;
  gap: 11px;
}

.project-cell__mark {
  display: grid;
  width: 38px;
  height: 38px;
  place-items: center;
  color: #9c583e;
  background: var(--creation-orange-soft);
  border: 1px solid #f2d2c6;
  border-radius: 10px;
  font-size: 13px;
}

.project-cell__mark.is-qa {
  color: var(--creation-violet);
  background: var(--creation-violet-soft);
  border-color: #ddd6e8;
}

.project-cell__mark.is-kg {
  color: var(--creation-green);
  background: var(--creation-green-soft);
  border-color: #cfe1da;
}

.project-cell > div > strong,
.project-cell > div > span,
.project-cell > div > p,
.target-cell small,
.state-cell strong,
.state-cell small,
.readiness-cell small,
.project-status strong,
.project-status small,
.update-cell strong,
.update-cell small {
  display: block;
}

.project-cell > div {
  min-width: 0;
}

.project-cell > div > strong {
  overflow: hidden;
  color: #2b302a;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.project-cell > div > span {
  margin-top: 5px;
  color: var(--creation-muted);
  font-size: 12px;
  font-weight: 700;
}

.project-cell > div > p {
  overflow: hidden;
  margin: 5px 0 0;
  color: var(--creation-subtle);
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.target-badge {
  display: inline-flex;
  min-width: 48px;
  min-height: 28px;
  align-items: center;
  justify-content: center;
  padding: 0 9px;
  color: #676e66;
  background: #eef0ed;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 700;
}

.target-badge.is-qa {
  color: var(--creation-violet);
  background: var(--creation-violet-soft);
}

.target-badge.is-kg {
  color: var(--creation-green);
  background: var(--creation-green-soft);
}

.target-badge.is-both {
  color: #a44728;
  background: var(--creation-orange-soft);
}

.target-cell small {
  margin-top: 7px;
  color: var(--creation-subtle);
  font-size: 12px;
  line-height: 1.45;
}

.source-dataset-cell {
  min-width: 0;
}

.state-cell strong {
  overflow: hidden;
  color: var(--creation-muted);
  font-size: 12px;
  font-weight: 700;
  line-height: 1.5;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.state-cell strong i {
  margin-right: 6px;
}

.state-cell.is-ready strong {
  color: var(--creation-green);
}

.state-cell.is-alert strong {
  color: #b54627;
}

.state-cell.is-waiting strong {
  color: var(--creation-muted);
}

.state-cell small {
  margin-top: 5px;
  overflow: hidden;
  color: var(--creation-subtle);
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 9px;
}

.dataset-tags span {
  padding: 4px 6px;
  color: #6f756c;
  background: #f1f3ef;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 700;
}

.readiness-cell > div:first-child {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.readiness-cell > div:first-child strong {
  overflow: hidden;
  color: #4c534b;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.readiness-cell > div:first-child span {
  color: var(--creation-olive);
  font-size: 12px;
  font-weight: 700;
}

.readiness-bar {
  height: 5px;
  margin-top: 9px;
  overflow: hidden;
  background: #e8ebe5;
  border-radius: 999px;
}

.readiness-bar > span {
  display: block;
  height: 100%;
  min-width: 5px;
  background: var(--creation-orange);
  border-radius: inherit;
  transition: width 220ms ease;
}

.readiness-bar > span.is-complete {
  background: var(--creation-green);
}

.readiness-bar > span.is-review {
  background: var(--creation-violet);
}

.readiness-bar > span.is-alert {
  background: #c9502e;
}

.readiness-bar > span.is-progress {
  background: var(--creation-olive);
}

.readiness-cell small {
  margin-top: 7px;
  overflow: hidden;
  color: var(--creation-subtle);
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.project-status strong {
  color: var(--creation-muted);
  font-size: 12px;
  font-weight: 700;
}

.project-status strong i {
  display: inline-block;
  width: 7px;
  height: 7px;
  margin-right: 7px;
  border-radius: 999px;
  background: #9da39b;
}

.project-status.is-complete strong {
  color: var(--creation-green);
}

.project-status.is-complete strong i {
  background: var(--creation-green);
}

.project-status.is-alert strong {
  color: #b54627;
}

.project-status.is-alert strong i {
  background: var(--creation-orange);
}

.project-status.is-review strong {
  color: var(--creation-violet);
}

.project-status.is-review strong i {
  background: var(--creation-violet);
}

.project-status.is-progress strong {
  color: #7a6237;
}

.project-status.is-progress strong i {
  background: #bd8b35;
}

.project-status small {
  margin-top: 7px;
  overflow: hidden;
  color: var(--creation-subtle);
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.update-cell {
  min-width: 0;
}

.update-cell strong {
  overflow: hidden;
  color: #596058;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.row-action {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
}

.row-action__primary {
  min-height: 36px;
  gap: 8px;
  padding: 0 12px;
  color: #fff;
  background: #343934;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.row-action__primary:hover {
  background: var(--creation-orange);
}

.row-action__delete {
  min-height: 36px;
  gap: 6px;
  padding: 0 10px;
  color: #a64e3d;
  background: #fff;
  border: 1px solid #e6c5bd;
  white-space: nowrap;
}

.row-action__delete:hover:not(:disabled) {
  color: #8d3d2f;
  background: #fff4f1;
  border-color: #d58b7a;
}

.row-action__delete:disabled {
  color: #aeb5b1;
  background: #f5f6f5;
  border-color: #e1e5e2;
  cursor: wait;
}

.project-empty {
  display: grid;
  min-height: 300px;
  place-items: center;
  align-content: center;
  gap: 8px;
  color: var(--creation-subtle);
  text-align: center;
}

.project-empty > span {
  display: grid;
  width: 48px;
  height: 48px;
  margin-bottom: 4px;
  place-items: center;
  color: var(--creation-olive);
  background: var(--creation-olive-soft);
  border-radius: 12px;
  font-size: 18px;
}

.project-empty strong {
  color: #4f574e;
  font-size: 13px;
}

.project-empty p {
  margin: 0;
  font-size: 12px;
}

.project-empty button {
  min-height: 36px;
  margin-top: 7px;
  padding: 0 13px;
  color: #fff;
  background: #343934;
}

.project-ledger__footer {
  color: var(--creation-muted);
  background: var(--creation-surface-muted);
  border-top: 1px solid var(--creation-line);
}

.project-ledger__footer > strong {
  color: #596058;
  font-weight: 700;
}

.project-ledger__footer > span {
  justify-self: end;
}

.pagination {
  display: flex;
  align-items: center;
  gap: 6px;
}

.pagination button {
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  color: var(--creation-muted);
  background: #fff;
  border: 1px solid var(--creation-line);
}

.pagination button.is-active {
  color: #fff;
  background: var(--creation-orange);
  border-color: var(--creation-orange);
}

.pagination button:disabled {
  color: #c3c8c1;
  background: #f1f3ef;
  cursor: default;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
}

.project-modal-backdrop,
.project-created-backdrop {
  position: fixed;
  inset: 0;
  z-index: 110;
  display: grid;
  place-items: center;
  padding: 20px;
  background: rgba(31, 36, 31, 0.66);
  backdrop-filter: blur(7px);
}

.project-modal,
.project-created-modal {
  width: min(620px, 100%);
  overflow: hidden;
  background: #fff;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 16px;
  box-shadow: 0 28px 80px rgba(20, 26, 20, 0.28);
  animation: modal-in 180ms ease both;
}

.project-modal > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 26px 28px 23px;
  background: var(--creation-surface-muted);
  border-bottom: 1px solid var(--creation-line);
}

.project-modal__heading > span,
.project-created-modal__body > p:first-of-type {
  display: flex;
  align-items: center;
  gap: 7px;
  color: var(--creation-orange);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.12em;
}

.project-modal > header h2 {
  margin: 8px 0 0;
  color: var(--creation-ink);
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.035em;
}

.project-modal > header p {
  max-width: 470px;
  margin: 8px 0 0;
  color: var(--creation-muted);
  font-size: 12px;
  line-height: 1.55;
}

.project-modal > header > button {
  display: grid;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  place-items: center;
  color: var(--creation-muted);
  background: #fff;
  border: 1px solid var(--creation-line);
  cursor: pointer;
}

.project-modal > header > button:hover {
  color: var(--creation-ink);
  border-color: var(--creation-line-strong);
}

.modal-body {
  display: grid;
  gap: 22px;
  padding: 25px 28px;
}

.field > span,
.output-choice > span {
  display: block;
  margin-bottom: 9px;
  color: #525a51;
  font-size: 12px;
  font-weight: 700;
}

.field > input {
  width: 100%;
  min-height: 46px;
  padding: 0 13px;
  color: var(--creation-ink);
  background: #fff;
  border: 1px solid var(--creation-line-strong) !important;
  border-radius: 8px;
  outline: 0;
  box-shadow: none !important;
  font-size: 12px;
  font-weight: 700;
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.field > input:focus {
  border-color: #83976a !important;
  box-shadow: 0 0 0 3px rgba(102, 125, 62, 0.1) !important;
}

.field > small {
  display: block;
  margin-top: 7px;
  color: var(--creation-subtle);
  font-size: 12px;
}

.output-choice {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.output-choice > span {
  grid-column: 1/-1;
}

.output-choice label {
  position: relative;
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr) 24px;
  min-height: 88px;
  align-items: center;
  gap: 11px;
  padding: 14px;
  background: var(--creation-surface-muted);
  border: 1px solid var(--creation-line);
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 160ms ease, border-color 160ms ease, box-shadow 160ms ease;
}

.output-choice label:hover {
  border-color: var(--creation-line-strong);
}

.output-choice label.is-checked {
  background: #fffaf7;
  border-color: #eca98f;
  box-shadow: 0 0 0 3px rgba(223, 89, 52, 0.07);
}

.output-choice label.is-disabled {
  color: #8d948c;
  background: #f3f4f1;
  border-color: #dfe3dd;
  cursor: not-allowed;
}

.output-choice label.is-disabled:hover {
  border-color: #dfe3dd;
}

.output-choice label.is-disabled .output-choice__icon,
.output-choice label.is-disabled .output-choice__check {
  color: #959c94;
  background: #e5e8e3;
}

.output-choice input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.output-choice__icon {
  display: grid;
  width: 42px;
  height: 42px;
  place-items: center;
  border-radius: 10px;
  font-size: 14px;
}

.output-choice__icon.is-qa {
  color: var(--creation-violet);
  background: var(--creation-violet-soft);
}

.output-choice__icon.is-kg {
  color: var(--creation-green);
  background: var(--creation-green-soft);
}

.output-choice label > div {
  min-width: 0;
}

.output-choice strong,
.output-choice small {
  display: block;
}

.output-choice strong {
  color: #343a33;
  font-size: 12px;
  font-weight: 700;
}

.output-choice small {
  margin-top: 5px;
  color: var(--creation-muted);
  font-size: 12px;
  line-height: 1.4;
}

.output-choice small.output-choice__preparing {
  color: #7c837b;
  font-weight: 700;
}

.output-choice__check {
  display: grid;
  width: 22px;
  height: 22px;
  place-items: center;
  color: #fff;
  background: #d4d9d2;
  border-radius: 6px;
  font-size: 12px;
}

.output-choice label.is-checked .output-choice__check {
  background: var(--creation-orange);
}

.contract-note {
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr);
  align-items: start;
  gap: 12px;
  padding: 16px;
  color: var(--creation-muted);
  background: var(--creation-olive-soft);
  border: 1px solid #dce5d2;
  border-radius: 10px;
}

.contract-note__icon {
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  color: var(--creation-olive);
  background: rgba(102, 125, 62, 0.1);
  border-radius: 8px;
  font-size: 12px;
}

.contract-note__copy {
  min-width: 0;
}

.contract-note strong {
  display: block;
  color: #4c5c3d;
  font-size: 12px;
  line-height: 1.4;
}

.contract-note p {
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 1.5;
}

.contract-note__status {
  display: inline-flex;
  max-width: 100%;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  padding: 6px 9px;
  color: #687067;
  background: rgba(255, 255, 255, 0.62);
  border: 1px solid rgba(102, 125, 62, 0.14);
  border-radius: 7px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.4;
}

.contract-note__status i {
  flex: 0 0 auto;
  color: #7d8876;
  font-size: 12px;
}

.project-modal > footer,
.project-created-modal > footer {
  display: flex;
  min-height: 76px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 28px;
  background: var(--creation-surface-muted);
  border-top: 1px solid var(--creation-line);
}

.project-modal > footer > div {
  display: flex;
  margin-left: auto;
  gap: 8px;
}

.modal-cancel,
.modal-submit,
.project-created-action {
  min-height: 42px;
  padding: 0 16px;
}

.modal-cancel {
  color: #5c645b;
  background: #fff;
  border: 1px solid var(--creation-line);
}

.modal-cancel:hover {
  background: #f1f3ef;
}

.modal-submit,
.project-created-action {
  gap: 9px;
  color: #fff;
  background: var(--creation-orange);
}

.modal-submit:hover,
.project-created-action:hover {
  background: var(--creation-orange-dark);
}

.modal-submit:disabled {
  color: #a7aca5;
  background: #e3e6e1;
  cursor: not-allowed;
}

.project-created-modal {
  max-width: 460px;
  text-align: center;
}

.project-created-modal__body {
  padding: 38px 32px 30px;
}

.project-created-modal__icon {
  display: grid;
  width: 54px;
  height: 54px;
  margin: 0 auto 17px;
  place-items: center;
  color: #fff;
  background: var(--creation-green);
  border-radius: 50%;
  box-shadow: 0 9px 22px rgba(46, 116, 93, 0.18);
  font-size: 17px;
}

.project-created-modal__body > p:first-of-type {
  justify-content: center;
  margin: 0;
}

.project-created-modal__body h2 {
  margin: 8px 0 0;
  color: var(--creation-ink);
  font-size: 23px;
  font-weight: 700;
  letter-spacing: -0.035em;
}

.project-created-modal__body > p:last-of-type {
  margin: 9px 0 0;
  color: var(--creation-muted);
  font-size: 12px;
  line-height: 1.55;
}

.project-created-summary {
  margin-top: 22px;
  padding: 15px;
  text-align: left;
  background: var(--creation-surface-muted);
  border: 1px solid var(--creation-line);
  border-radius: 10px;
}

.project-created-summary > span,
.project-created-summary > strong {
  display: block;
}

.project-created-summary > span {
  color: var(--creation-subtle);
  font-size: 12px;
}

.project-created-summary > strong {
  margin-top: 5px;
  color: #343a33;
  font-size: 12px;
}

.project-created-summary > div {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 12px;
}

.project-created-summary em {
  padding: 5px 8px;
  color: #a44728;
  background: var(--creation-orange-soft);
  border-radius: 5px;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.project-created-modal > footer {
  justify-content: center;
}

@keyframes row-in {
  from {
    opacity: 0;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes modal-in {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 1280px) {
  .creation-overview {
    grid-template-columns: minmax(230px, 1.2fr) repeat(3, minmax(150px, 1fr));
  }
  .project-ledger__table th:nth-child(6),
  .project-ledger__table td:nth-child(6) {
    display: none;
  }
  .project-ledger__table th:nth-child(1) {
    width: 22%;
  }
  .project-ledger__table th:nth-child(2) {
    width: 12%;
  }
  .project-ledger__table th:nth-child(3) {
    width: 19%;
  }
  .project-ledger__table th:nth-child(4) {
    width: 22%;
  }
  .project-ledger__table th:nth-child(5) {
    width: 13%;
  }
  .project-ledger__table th:nth-child(7) {
    width: 12%;
  }
}
@media (max-width: 1040px) {
  .creation-overview {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .creation-overview__intro {
    grid-column: 1/-1;
    min-height: 104px !important;
  }
  .creation-overview > article:nth-child(2) {
    border-left: 0;
  }
  .creation-path {
    grid-template-columns: 1fr;
  }
  .creation-path__header {
    border-right: 0;
    border-bottom: 1px solid var(--creation-line);
  }
  .project-ledger__table th:nth-child(3),
  .project-ledger__table td:nth-child(3) {
    display: none;
  }
  .project-ledger__table th:nth-child(1) {
    width: 27%;
  }
  .project-ledger__table th:nth-child(2) {
    width: 14%;
  }
  .project-ledger__table th:nth-child(4) {
    width: 27%;
  }
  .project-ledger__table th:nth-child(5) {
    width: 16%;
  }
  .project-ledger__table th:nth-child(7) {
    width: 16%;
  }
}
@media (max-width: 820px) {
  .creation-header__actions {
    width: 100%;
  }
  .creation-primary {
    margin-left: auto;
  }
  .creation-overview {
    grid-template-columns: 1fr;
  }
  .creation-overview__intro {
    grid-column: auto;
  }
  .creation-overview > article + article {
    border-top: 1px solid var(--creation-line);
    border-left: 0;
  }
  .creation-metric {
    min-height: 96px !important;
  }
  .creation-path__steps {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .creation-path__steps li:nth-child(3) {
    border-left: 0;
  }
  .creation-path__steps li:nth-child(n+3) {
    border-top: 1px solid #ecefe9;
  }
  .project-card-list {
    background: #f1f3ef;
  }
  .project-card {
    padding: 18px;
    background: #fff;
    border: 1px solid var(--creation-line);
    border-radius: 11px;
    animation: row-in 0.24s ease both;
  }
  .project-card header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
  }
  .project-card__identity {
    display: grid;
    grid-template-columns: 38px minmax(0, 1fr);
    align-items: center;
    gap: 11px;
    min-width: 0;
  }
  .project-card__identity > div {
    min-width: 0;
  }
  .project-card__identity strong,
  .project-card__identity span {
    display: block;
  }
  .project-card__identity strong {
    overflow: hidden;
    color: var(--creation-ink);
    font-size: 13px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .project-card__identity span {
    margin-top: 5px;
    color: var(--creation-muted);
    font-size: 12px;
  }
  .project-card__progress {
    margin-top: 18px;
  }
  .project-card__progress > div:first-child {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    color: #50584f;
    font-size: 12px;
  }
  .project-card__progress p {
    margin: 7px 0 0;
    color: var(--creation-subtle);
    font-size: 12px;
  }
  .project-card dl {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    margin: 16px 0 0;
  }
  .project-card dl div {
    padding: 11px;
    background: var(--creation-surface-muted);
    border-radius: 8px;
  }
  .project-card dt {
    color: var(--creation-subtle);
    font-size: 12px;
    font-weight: 700;
  }
  .project-card dd {
    margin: 5px 0 0;
    color: #4f574e;
    font-size: 12px;
    font-weight: 700;
  }
  .project-card__actions {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 8px;
    margin-top: 14px;
  }
  .project-card__actions button {
    min-height: 42px;
    gap: 9px;
  }
  .project-card__open {
    width: 100%;
    color: #fff;
    background: #343934;
  }
  .project-card__delete {
    min-width: 76px;
    padding: 0 13px;
    color: #a64e3d;
    background: #fff;
    border: 1px solid #e6c5bd;
  }
  .project-card__delete:disabled {
    color: #aeb5b1;
    background: #f5f6f5;
    border-color: #e1e5e2;
    cursor: wait;
  }
}
@media (max-width: 560px) {
  .creation-shell {
    width: min(100% - 24px, 1480px);
  }
  .creation-header__actions {
    flex-wrap: wrap;
  }
  .creation-utility {
    display: none;
  }
  .creation-primary {
    width: 100%;
    margin: 0;
  }
  .creation-path__steps {
    grid-template-columns: 1fr;
  }
  .creation-path__steps li + li,
  .creation-path__steps li:nth-child(3) {
    border-top: 1px solid #ecefe9;
    border-left: 0;
  }
  .project-ledger__footer .pagination {
    display: none;
  }
  .project-card header {
    align-items: flex-start;
  }
  .project-card dl {
    grid-template-columns: 1fr;
  }
  .output-choice {
    grid-template-columns: 1fr;
  }
  .project-modal-backdrop,
  .project-created-backdrop {
    align-items: end;
    padding: 10px;
  }
  .project-modal,
  .project-created-modal {
    max-height: calc(100vh - 20px);
    overflow-y: auto;
    border-radius: 14px;
  }
  .project-modal > header,
  .project-created-modal__body,
  .modal-body {
    padding-inline: 20px;
  }
  .project-modal > footer,
  .project-created-modal > footer {
    padding-inline: 20px;
  }
  .project-modal > footer > div {
    width: 100%;
  }
  .project-modal > footer button {
    flex: 1;
  }
}
@media (prefers-reduced-motion: reduce) {
  .project-ledger__table tbody tr,
  .project-card,
  .project-modal,
  .project-created-modal {
    animation: none;
  }
  .creation-utility,
  .creation-primary,
  .project-filter-tabs button,
  .row-action button,
  .readiness-bar > span {
    transition: none;
  }
}
/* Unified operations header ------------------------------------------------ */
.creation-header .creation-header__inner {
  box-sizing: border-box;
}

.creation-heading {
  display: grid;
  gap: 5px;
  min-width: 0;
}

.creation-eyebrow {
  width: fit-content;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.15em;
  line-height: 1.2;
}

.creation-heading .reviewops-page-title {
  margin: 0;
}

.creation-heading > p:last-child {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.45;
}

.creation-header__actions {
  align-self: center;
  margin-left: auto;
}

.creation-primary {
  min-height: 42px;
  margin-left: 0;
  padding: 0 19px;
}

@media (max-width: 920px) {
  .creation-header__actions {
    width: 100%;
    align-self: stretch;
    margin-left: 0;
  }
  .creation-primary {
    width: 100%;
  }
}
/* Brighter project workspace surfaces ------------------------------------- */
.creation-page {
  --creation-surface: #ffffff;
  --creation-surface-muted: #fbfcfa;
}

.creation-page .creation-overview,
.creation-page .creation-path,
.creation-page .project-ledger,
.creation-page .project-card,
.creation-page .creation-path__header,
.creation-page .project-ledger__header,
.creation-page .project-filter-tabs {
  background: #ffffff !important;
}

.creation-page .creation-overview,
.creation-page .creation-path,
.creation-page .project-ledger,
.creation-page .project-card {
  border-color: #e3e7e1 !important;
}

.creation-page .creation-overview__intro {
  color: var(--creation-ink);
  background: #fff7f2 !important;
  box-shadow: inset 4px 0 0 var(--creation-orange);
}

.creation-page .creation-overview__intro > span {
  color: var(--creation-orange);
}

.creation-page .creation-overview__intro strong {
  color: var(--creation-ink);
}

.creation-page .creation-overview__intro p {
  color: var(--creation-muted);
}

/* Keep the primary list action beside search instead of in the page header. */
:host-context(.reviewops-shell) .creation-page .project-ledger__controls .project-search {
  justify-self: end;
}

:host-context(.reviewops-shell) .creation-page .creation-primary--ledger {
  width: auto !important;
  min-height: 42px;
  margin: 0 !important;
  padding-inline: 16px;
  white-space: nowrap;
}

@media (max-width: 920px) {
  :host-context(.reviewops-shell) .creation-page .creation-primary--ledger {
    width: 100% !important;
  }
}
/* The footer owns the final divider; avoid a second line from the last row. */
:host-context(.reviewops-shell) .creation-page .project-ledger__table tbody > tr:last-child > td {
  border-bottom: 0 !important;
}

/* QA list only: entity pages import this file, so every added rule requires this root. */
:host-context(.reviewops-shell) .qa-project-list .project-ledger__table th {
  width: auto;
}
:host-context(.reviewops-shell) .qa-project-list .project-ledger__table th,
:host-context(.reviewops-shell) .qa-project-list .project-ledger__table td {
  display: table-cell;
}
:host-context(.reviewops-shell) .qa-project-list .project-ledger__column--metadata {
  width: 180px;
}
:host-context(.reviewops-shell) .qa-project-list .project-ledger__column--actions {
  width: 164px;
}
:host-context(.reviewops-shell) .qa-project-list .target-cell {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 8px;
  margin-top: 12px;
}
:host-context(.reviewops-shell) .qa-project-list .target-cell small {
  margin: 0;
}
:host-context(.reviewops-shell) .qa-project-list .source-dataset-cell {
  margin-top: 12px;
}
:host-context(.reviewops-shell) .qa-project-list .project-status {
  margin-top: 16px;
}
:host-context(.reviewops-shell) .qa-project-list .project-metadata {
  display: grid;
  gap: 12px;
  margin: 0;
}
:host-context(.reviewops-shell) .qa-project-list .project-metadata dt {
  color: var(--creation-muted);
}
:host-context(.reviewops-shell) .qa-project-list .project-metadata dd {
  margin: 4px 0 0;
  color: var(--creation-ink);
  font-weight: 600;
}
:host-context(.reviewops-shell) .qa-project-list .row-action {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  min-width: 0;
  justify-items: stretch;
  gap: 8px;
}
:host-context(.reviewops-shell) .qa-project-list .project-cell > div > strong,
:host-context(.reviewops-shell) .qa-project-list .project-cell > div > span,
:host-context(.reviewops-shell) .qa-project-list .project-cell > div > p,
:host-context(.reviewops-shell) .qa-project-list .state-cell strong,
:host-context(.reviewops-shell) .qa-project-list .state-cell small,
:host-context(.reviewops-shell) .qa-project-list .readiness-cell > div:first-child strong,
:host-context(.reviewops-shell) .qa-project-list .readiness-cell small,
:host-context(.reviewops-shell) .qa-project-list .project-status small,
:host-context(.reviewops-shell) .qa-project-list .project-metadata dd,
:host-context(.reviewops-shell) .qa-project-list .project-card__identity strong,
:host-context(.reviewops-shell) .qa-project-list .project-card__identity span,
:host-context(.reviewops-shell) .qa-project-list .project-card dd {
  overflow: visible;
  white-space: normal;
  text-overflow: clip;
  word-break: normal;
  overflow-wrap: anywhere;
}
:host-context(.reviewops-shell) .qa-project-list .readiness-cell > div:first-child {
  flex-wrap: wrap;
}
:host-context(.reviewops-shell) .qa-project-list .row-action > a,
:host-context(.reviewops-shell) .qa-project-list .row-action > button,
:host-context(.reviewops-shell) .qa-project-list .project-card__actions > a,
:host-context(.reviewops-shell) .qa-project-list .project-card__actions > button {
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding-inline: 12px;
  white-space: nowrap;
  overflow-wrap: normal;
}
:host-context(.reviewops-shell) .qa-project-list .row-action i,
:host-context(.reviewops-shell) .qa-project-list .project-card__actions i {
  flex: 0 0 auto;
}
@media (max-width: 1023px) {
  :host-context(.reviewops-shell) .qa-project-list .project-card-list {
    background: #f1f3ef;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card {
    padding: 18px;
    background: #fff;
    border: 1px solid var(--creation-line);
    border-radius: 11px;
    animation: row-in 0.24s ease both;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__identity {
    display: grid;
    grid-template-columns: 38px minmax(0, 1fr);
    align-items: center;
    gap: 11px;
    min-width: 0;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__identity > div {
    min-width: 0;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__identity strong,
  :host-context(.reviewops-shell) .qa-project-list .project-card__identity span {
    display: block;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__identity strong {
    overflow: hidden;
    color: var(--creation-ink);
    font-size: 13px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__identity span {
    margin-top: 5px;
    color: var(--creation-muted);
    font-size: 12px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__progress {
    margin-top: 18px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__progress > div:first-child {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    color: #50584f;
    font-size: 12px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__progress p {
    margin: 7px 0 0;
    color: var(--creation-subtle);
    font-size: 12px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card dl {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    margin: 16px 0 0;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card dl div {
    padding: 11px;
    background: var(--creation-surface-muted);
    border-radius: 8px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card dt {
    color: var(--creation-subtle);
    font-size: 12px;
    font-weight: 700;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card dd {
    margin: 5px 0 0;
    color: #4f574e;
    font-size: 12px;
    font-weight: 700;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__actions {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 8px;
    margin-top: 14px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__actions button {
    min-height: 42px;
    gap: 9px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__open {
    width: 100%;
    color: #fff;
    background: #343934;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__delete {
    min-width: 76px;
    padding: 0 13px;
    color: #a64e3d;
    background: #fff;
    border: 1px solid #e6c5bd;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__delete:disabled {
    color: #aeb5b1;
    background: #f5f6f5;
    border-color: #e1e5e2;
    cursor: wait;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__identity strong,
  :host-context(.reviewops-shell) .qa-project-list .project-card__identity span,
  :host-context(.reviewops-shell) .qa-project-list .project-card dd {
    overflow: visible;
    white-space: normal;
    text-overflow: clip;
    overflow-wrap: anywhere;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card__actions {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 92px;
    gap: 8px;
  }
}
@media (max-width: 560px) {
  :host-context(.reviewops-shell) .qa-project-list .project-card dl {
    grid-template-columns: 1fr;
  }
}

/* 11: workspace information hierarchy and shared component roles. */
:host-context(.reviewops-shell) .qa-project-list .project-ledger__title p {
  margin: 0;
}
:host-context(.reviewops-shell) .qa-project-list .qa-list-filters {
  border-bottom: 1px solid var(--ro-line);
}
:host-context(.reviewops-shell) .qa-project-list .qa-list-filters > summary {
  min-height: 44px;
  padding: 10px 16px;
  cursor: pointer;
  color: var(--ro-ink);
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
}
:host-context(.reviewops-shell) .qa-project-list .qa-project-details {
  margin-top: 8px;
}
:host-context(.reviewops-shell) .qa-project-list .qa-project-details > summary {
  cursor: pointer;
  min-height: 44px;
  padding-block: 10px;
  color: var(--ro-accent);
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
}
:host-context(.reviewops-shell) .qa-project-list .project-cell {
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr);
  align-items: start;
  gap: 12px;
}
:host-context(.reviewops-shell) .qa-project-list .project-cell__mark {
  position: static;
  display: grid;
  place-items: center;
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  margin: 0;
}
:host-context(.reviewops-shell) .qa-project-list .project-cell__mark > i {
  position: static;
  margin: 0;
}
:host-context(.reviewops-shell) .qa-project-list .project-cell > div {
  min-width: 0;
}
:host-context(.reviewops-shell) .qa-project-list .project-cell > div > strong, :host-context(.reviewops-shell) .qa-project-list .project-card__identity strong {
  word-break: keep-all;
}
:host-context(.reviewops-shell) .qa-project-list .target-cell, :host-context(.reviewops-shell) .qa-project-list .source-dataset-cell, :host-context(.reviewops-shell) .qa-project-list .project-status {
  margin-top: 4px;
}
:host-context(.reviewops-shell) .qa-project-list .project-metadata {
  gap: 4px;
}
:host-context(.reviewops-shell) .qa-project-list .project-metadata > div {
  display: flex;
  flex-wrap: wrap;
  gap: 0 8px;
}
:host-context(.reviewops-shell) .qa-project-list .project-metadata dd {
  margin-top: 0;
}
:host-context(.reviewops-shell) .qa-project-list .project-card__state {
  display: grid;
  gap: 4px;
  margin: 12px 0;
  font-size: 14px;
  line-height: 22px;
}
:host-context(.reviewops-shell) .qa-project-list .project-card__state strong {
  color: var(--ro-ink);
}
:host-context(.reviewops-shell) .qa-project-list .project-card__state span {
  color: var(--ro-muted);
}
:host-context(.reviewops-shell) .qa-project-list .project-card__identity {
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr);
  gap: 12px;
  align-items: start;
}
:host-context(.reviewops-shell) .qa-project-list .project-card__identity > .project-cell__mark {
  grid-column: 1;
  grid-row: 1;
}
:host-context(.reviewops-shell) .qa-project-list .project-card__identity > div {
  grid-column: 2;
  grid-row: 1;
  min-width: 0;
}
:host-context(.reviewops-shell) .qa-project-list .project-card dl {
  margin-top: 8px;
}
:host-context(.reviewops-shell) .qa-project-list .project-card dl > div {
  padding: 8px 0;
  background: transparent;
  border-bottom: 1px solid var(--ro-line);
  border-radius: 0;
}
:host-context(.reviewops-shell) .qa-project-list .project-card__actions {
  margin-top: 8px;
}
@media (max-width: 639px) {
  :host-context(.reviewops-shell) .qa-project-list .qa-list-filters > summary {
    padding-inline: 16px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card {
    padding: 16px;
    border-radius: 12px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card header {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 8px;
  }
  :host-context(.reviewops-shell) .qa-project-list .project-card header > .target-badge {
    justify-self: start;
  }
}

.entity-page {
  color: #30372f;
  min-height: 100%;
  background: var(--ro-canvas, #fafbf8);
}

.entity-page *, .entity-page *::before, .entity-page *::after {
  box-sizing: border-box;
}

.e-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid #d9dfd5;
  border-radius: 8px;
  background: #fff;
  padding: 10px 14px;
  min-height: 40px;
  color: #394035;
  font: inherit;
  font-size: 13px;
  font-weight: 650;
  text-decoration: none;
  cursor: pointer;
}

.e-button:hover {
  background: #f2f5ec;
  border-color: #aab79a;
}

.e-button--primary {
  background: #3b4237;
  color: #fff;
  border-color: #3b4237;
}

.e-button--primary:hover {
  background: #525d45;
  color: #fff;
}

.e-button:disabled, .e-text-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.entity-page button:focus-visible, .entity-page a:focus-visible, .entity-page input:focus-visible, .entity-page select:focus-visible, .entity-page textarea:focus-visible {
  outline: 3px solid #ef603b;
  outline-offset: 3px;
}

.e-text-button {
  border: 0;
  background: transparent;
  color: #a2452c;
  padding: 8px;
  font: inherit;
  font-size: 12px;
  cursor: pointer;
}

.e-back {
  display: inline-flex;
  gap: 8px;
  align-items: center;
  font-size: 12px;
  color: #697561;
  text-decoration: none;
  margin-bottom: 14px;
}

.e-item-link {
  color: #30372f;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
}

.e-item-link:hover {
  color: #b34429;
  text-decoration: underline;
}

.e-notice, .e-error {
  padding: 14px 18px;
  border-radius: 9px;
  margin: 0 0 18px;
  line-height: 1.7;
  font-size: 13px;
  overflow-wrap: anywhere;
}

.e-notice {
  color: #775c25;
  border: 1px solid #ecdfbd;
  background: #fffaf0;
}

.e-error {
  color: #9c3529;
  border: 1px solid #edc9c2;
  background: #fff5f2;
}

.e-error p, .e-notice p {
  margin: 4px 0;
}

.e-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 24px;
}

.e-metrics article {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 20px 24px;
  background: #fff;
  border: 1px solid #e1e5dc;
  border-radius: 12px;
}

.e-metrics span {
  font-size: 12px;
  color: #74806b;
}

.e-metrics strong {
  font-size: 27px;
  letter-spacing: -0.5px;
}

.e-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 6px;
  padding: 5px 8px;
  background: #edf3e6;
  color: #596c40;
  font-size: 12px;
  font-weight: 650;
  white-space: normal;
}

.e-badge--muted {
  background: #f1f1eb;
  color: #777d70;
}

.e-tag-group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.e-tag-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border: 1px solid #d8dee8;
  border-radius: 999px;
  padding: 3px 9px;
  font-size: 12px;
  line-height: 1.5;
  font-weight: 650;
  color: #596273;
  background: #f3f5f8;
  white-space: nowrap;
}

.e-tag-badge[data-tag-state=present] {
  color: #1d4f91;
  background: #edf4ff;
  border-color: #c9dcf6;
}

.e-tag-badge[data-tag-state=absent] {
  color: #875418;
  background: #fff6e7;
  border-color: #edd6b3;
}

.e-tag-badge[data-tag-state=mixed] {
  color: #654499;
  background: #f4effc;
  border-color: #ded0ef;
}

.e-subtext {
  display: block;
  margin-top: 5px;
  font-size: 12px;
  color: #7d8777;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.e-muted {
  font-size: 12px;
  color: #7a8473;
  line-height: 1.75;
  margin: 12px 0;
  overflow-wrap: anywhere;
}

.e-empty {
  padding: 34px 20px;
  text-align: center;
  color: #7b8573;
  font-size: 13px;
  line-height: 1.8;
}

.e-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 18px 22px;
  border-top: 1px solid #e7eae3;
  font-size: 12px;
  color: #79836f;
}

.e-pagination > div {
  display: flex;
  align-items: center;
  gap: 14px;
}

.e-project-table {
  min-width: 650px;
}

.e-project-table th, .e-project-table td {
  display: table-cell !important;
}

.e-project-table th:nth-child(1) {
  width: 36% !important;
}

.e-project-table th:nth-child(2) {
  width: 12% !important;
}

.e-project-table th:nth-child(3) {
  width: 20% !important;
}

.e-project-table th:nth-child(4) {
  width: 19% !important;
}

.e-project-table th:nth-child(5) {
  width: 13% !important;
}

.e-list-cards {
  display: none;
}

.e-list-card {
  padding: 18px;
  border-bottom: 1px solid #e7ebdf;
}

.e-list-card__status {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 12px;
  font-size: 12px;
}

.e-list-card > .e-button {
  margin-top: 12px;
  width: 100%;
}

.e-card {
  min-width: 0;
  border: 1px solid #e1e5dc;
  border-radius: 12px;
  background: #fff;
  padding: 24px;
  margin-bottom: 22px;
}

.e-card__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
}

.e-card h2 {
  font-size: 18px;
  margin: 0;
  font-weight: 750;
}

.e-card h3 {
  font-size: 16px;
  line-height: 1.7;
  overflow-wrap: anywhere;
}

.e-card h4 {
  font-size: 13px;
  font-weight: 700;
  margin: 12px 0;
}

.e-eyebrow {
  font-size: 12px;
  letter-spacing: 1.4px;
  color: #db5b36;
  display: block;
  margin-bottom: 8px;
}

.e-description {
  font-size: 13px;
  line-height: 1.8;
  color: #66715e;
  margin-bottom: 14px;
}

.e-source-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.e-source-list article {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #f8f9f5;
  border-radius: 8px;
  font-size: 12px;
}

.e-source-list article > div {
  min-width: 0;
  overflow-wrap: anywhere;
}

.e-source-list .e-badge {
  flex-shrink: 0;
}

.e-two-panel {
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr);
  align-items: start;
  gap: 22px;
}

.e-tree {
  max-height: 540px;
  overflow: auto;
  margin: 12px -10px 0;
}

.e-tree-row {
  display: flex;
  align-items: flex-start;
  border-radius: 6px;
  padding-top: 6px;
  padding-bottom: 6px;
  border-bottom: 1px solid #f0f2ec;
}

.e-tree-row.is-selected {
  background: #fff1e9;
}

.e-tree-toggle {
  flex: 0 0 26px;
  width: 26px;
  height: 32px;
  border: 0;
  background: none;
  font-size: 12px;
  color: #78846c;
  cursor: pointer;
}

.e-tree-toggle:disabled {
  opacity: 0.35;
  cursor: default;
}

.e-tree-title {
  text-align: left;
  border: 0;
  background: none;
  padding: 5px;
  flex: 1;
  min-width: 0;
  cursor: pointer;
  color: #394232;
}

.e-tree-title strong {
  font-size: 12px;
  line-height: 1.7;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.e-tree-title small {
  display: block;
  font-size: 12px;
  color: #87917d;
  line-height: 1.7;
  margin-top: 4px;
}

.e-search {
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid #dce2d6;
  padding: 10px 12px;
  border-radius: 8px;
  color: #839077;
}

.e-search input {
  min-width: 0;
  width: 100%;
  border: 0;
  outline: none;
  background: none;
  font-size: 12px;
}

.e-analysis {
  margin: 20px 0;
}

.e-analysis > div {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #edf0e7;
  padding: 12px 0;
  font-size: 13px;
}

.e-analysis dt {
  color: #7b8671;
}

.e-type-list {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin: 9px 0 18px;
}

.e-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 14px 0;
  font-size: 12px;
  color: #6a765e;
}

.e-field input, .e-field select, .e-field textarea, .e-filters input, .e-filters select {
  width: 100%;
  min-width: 0;
  padding: 10px 12px;
  border: 1px solid #dce2d6;
  border-radius: 7px;
  background: #fff;
  color: #3d4636;
  font: inherit;
  font-size: 12px;
}

.e-field textarea {
  resize: vertical;
}

.e-reviewer-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.e-reviewer-grid > label {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px;
  border: 1px solid #e5e9df;
  border-radius: 8px;
  cursor: pointer;
}

.e-reviewer-grid input {
  accent-color: #778c35;
  margin-top: 4px;
}

.e-reviewer-grid strong {
  font-size: 13px;
}

.e-reviewer-grid small {
  display: block;
  color: #8c9582;
  font-size: 12px;
  margin-top: 6px;
  overflow-wrap: anywhere;
}

.e-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.e-job {
  margin-top: 18px;
  border-radius: 8px;
  background: #f4f7ee;
  padding: 14px;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.e-job progress {
  width: 100%;
  accent-color: #8ca13c;
}

.e-history {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  padding: 12px 0;
  border-top: 1px solid #eef0e9;
  font-size: 12px;
}

.e-history > span {
  color: #859078;
}

.e-result-main {
  max-width: 2100px;
  padding: 22px;
  margin: 0 auto;
}

.e-workbench {
  display: grid;
  grid-template-columns: minmax(230px, 0.75fr) minmax(320px, 1.45fr) minmax(300px, 1fr);
  align-items: start;
  gap: 16px;
}

.e-workbench .e-card {
  padding: 18px;
}

.e-workbench .e-tree {
  max-height: 74vh;
}

.e-source-text {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  line-height: 28px;
  font-size: 16px;
  max-height: 64vh;
  overflow-y: auto;
  padding: 18px 4px;
  color: #3d4537;
}

.e-source-text .is-entity {
  background: #f8eccb;
  border-radius: 3px;
  cursor: pointer;
}

.e-source-text .is-active {
  background: #ffc9a9;
  outline: 1px solid #df6a36;
}

.e-breadcrumbs {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.e-breadcrumbs button {
  border: 0;
  background: none;
  font-size: 12px;
  color: #858f7b;
  cursor: pointer;
  text-align: left;
}

.e-filters {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin: 12px 0;
}

.e-filters > input {
  grid-column: 1/-1;
}

.e-occurrences {
  max-height: 34vh;
  overflow: auto;
}

.e-occurrence {
  width: 100%;
  border: 1px solid #e7ebdf;
  background: #fff;
  padding: 12px;
  margin-bottom: 8px;
  border-radius: 8px;
  text-align: left;
  cursor: pointer;
  color: #3e4835;
}

.e-occurrence.is-active {
  border-color: #e77d4e;
  background: #fff6ef;
}

.e-occurrence__heading {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 13px;
}

.e-occurrence > small {
  display: block;
  margin-top: 8px;
  font-size: 12px;
  line-height: 1.8;
  color: #7d8971;
  overflow-wrap: anywhere;
}

.e-occurrence strong {
  overflow-wrap: anywhere;
}

.e-editor, .e-complete, .e-manual, .e-attachments {
  border-top: 1px solid #e8ecdf;
  margin-top: 20px;
  padding-top: 14px;
}

.e-attachments article {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 8px 0;
  font-size: 12px;
  overflow-wrap: anywhere;
}

@media (max-width: 1250px) {
  .e-workbench {
    grid-template-columns: 230px minmax(0, 1fr);
  }
  .e-occurrence-panel {
    grid-column: 1/-1;
  }
  .e-occurrences {
    max-height: 400px;
  }
  .e-reviewer-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 760px) {
  .e-metrics {
    gap: 8px;
  }
  .e-metrics article {
    padding: 14px 10px;
  }
  .e-metrics strong {
    font-size: 22px;
  }
  .e-metrics span {
    font-size: 12px;
  }
  .e-two-panel, .e-workbench, .e-source-list {
    grid-template-columns: 1fr;
  }
  .e-card {
    padding: 18px;
  }
  .e-workbench .e-tree {
    max-height: 300px;
  }
  .e-workbench .e-occurrence-panel {
    grid-column: auto;
  }
  .e-result-main {
    padding: 14px;
  }
  .e-reviewer-grid {
    grid-template-columns: 1fr;
  }
  .e-pagination {
    padding: 14px;
  }
  .e-pagination > div {
    gap: 8px;
  }
}
@media (max-width: 1050px) {
  .entity-page .project-ledger__table-wrap {
    display: none;
  }
  .e-list-cards {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 760px) {
  .e-list-cards {
    grid-template-columns: 1fr;
  }
}
.review-list .review-ledger {
  background: #fff;
  border: 1px solid #dce2d8;
}
.review-list h2 {
  font-size: 18px;
  margin: 0 0 10px;
}
.review-list .review-ledger__header > h2 {
  flex: 0 1 320px;
  margin: 0;
}
.review-list .review-ledger__controls {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 540px;
  align-items: flex-end;
  gap: 12px;
  min-width: 0;
}
.review-list .review-ledger__controls > .review-search {
  flex: 1 1 280px;
}
.review-list .review-ledger__controls > .review-filter {
  flex: 0 1 200px;
  min-width: 0;
}
.review-list .review-search, .review-list .review-filter {
  display: grid;
  gap: 6px;
  margin: 0;
  font-size: 12px;
  color: #4c5945;
}
.review-list .review-search > span, .review-list .review-filter > span {
  font-weight: 600;
}
.review-list .review-search {
  min-width: 0;
}
.review-list .review-search > div {
  display: flex;
  gap: 6px;
  min-width: 0;
}
.review-list .review-search input {
  flex: 1 1 0%;
}
.review-list .review-search > div > .e-button {
  flex: 0 0 auto;
  white-space: nowrap;
  min-width: 44px;
  min-height: 44px;
}
.review-list input, .review-list select {
  width: 100%;
  min-width: 0;
  min-height: 44px;
  border: 1px solid #bfcbb9;
  border-radius: 7px;
  padding: 10px;
  background: #fff;
  color: #30372f;
  font: inherit;
}
.review-list input::-webkit-search-cancel-button {
  display: none;
}
.review-list input::-ms-clear {
  display: none;
}
.review-list .review-flow, .review-list .review-count {
  padding: 10px 20px;
  margin: 0;
  color: #4c5945;
  font-size: 12px;
  line-height: 1.65;
}
.review-list .review-flow {
  background: #f4f7f0;
}
.review-list .review-count:focus {
  outline: 3px solid #b34429;
  outline-offset: -3px;
}
.review-list .review-project {
  display: grid;
  grid-template-columns: minmax(0, 1.5fr) minmax(0, 1fr) auto;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
  color: #30372f;
  border-top: 1px solid #e1e6dc;
  text-decoration: none;
  word-break: keep-all;
  overflow-wrap: anywhere;
}
.review-list .review-project:hover, .review-list .review-project[aria-current] {
  background: #f6f9f2;
}
.review-list .review-project__name {
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr);
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.review-list .review-project__icon {
  display: grid;
  width: 38px;
  height: 38px;
  place-items: center;
  border: 1px solid #ddd6e8;
  border-radius: 10px;
  background: #f0edf6;
  color: #655781;
}
.review-list .review-project__copy {
  min-width: 0;
}
.review-list .review-project h3 {
  margin: 0;
  font-size: 16px;
  line-height: 1.6;
  overflow-wrap: anywhere;
}
.review-list .review-project p {
  margin: 5px 0 0;
  font-size: 12px;
  color: #53614c;
}
.review-list .review-project .review-project__identifier {
  line-height: 1.6;
  overflow-wrap: anywhere;
}
.review-list .review-project__state {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 4px;
  font-size: 13px;
}
.review-list .review-project small {
  font-size: 12px;
  color: #53614c;
}
.review-list .review-project__action {
  justify-self: end;
  gap: 8px;
  min-height: 44px;
  font-size: 14px;
  font-weight: 600;
}
.review-list .review-pagination {
  display: grid !important;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  gap: 12px;
}
.review-list .review-pagination__pages {
  justify-content: center;
}
.review-list .review-pagination__pages button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  min-height: 44px;
  border: 1px solid #dfe3dc;
  background: #fff;
  color: #747b74;
  cursor: pointer;
}
.review-list .review-pagination__pages button:hover:not(:disabled) {
  background: #f3f7f3;
  border-color: #9daa9e;
  color: #41604f;
}
.review-list .review-pagination__pages button:disabled {
  background: #f4f5f2;
  color: #c7cbc5;
  cursor: default;
}
.review-list .review-pagination__hint {
  min-width: 0;
  text-align: right;
}
.review-list .review-help {
  margin: 16px 0;
  padding: 14px 18px;
  border: 1px solid #dce2d8;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.8;
  color: #485440;
  background: #fff;
}
.review-list summary {
  cursor: pointer;
  min-height: 32px;
  font-weight: 600;
}
.review-list .e-error {
  margin: 12px;
}
@media (max-width: 1023px) {
  .review-list .creation-header {
    height: auto !important;
    max-height: none !important;
  }
  .review-list .creation-header__inner {
    height: auto !important;
    max-height: none !important;
  }
  .review-list .review-pagination {
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .review-list .review-pagination__hint {
    grid-column: 1/-1;
    text-align: left;
  }
}
@media (max-width: 1100px) {
  .review-list .review-ledger__header > h2, .review-list .review-ledger__controls {
    flex-basis: 100%;
  }
}
@media (max-width: 639px) {
  .review-list .review-ledger__controls {
    flex-direction: column;
    align-items: stretch;
  }
  .review-list .review-ledger__controls > .review-search, .review-list .review-ledger__controls > .review-filter {
    flex: 0 1 auto;
    width: 100%;
  }
  .review-list .review-pagination {
    grid-template-columns: minmax(0, 1fr);
  }
  .review-list .review-pagination__pages {
    justify-self: center;
  }
  .review-list .review-pagination__pages .review-page--compact-hidden {
    display: none;
  }
}
@media (max-width: 600px) {
  .review-list .review-search > span, .review-list .review-filter > span {
    font-size: 12px;
  }
  .review-list .review-project {
    grid-template-columns: minmax(0, 1fr);
    gap: 10px;
    padding: 16px;
  }
  .review-list .review-project__state {
    gap: 5px;
  }
  .review-list .review-project__action {
    justify-self: start;
  }
  .review-list .review-flow, .review-list .review-count {
    padding: 8px 14px;
  }
}`],
})
export class PageEntityReviewsComponent implements OnInit, OnDestroy {
    public projects: any[] = [];
    public unresolved: any[] = [];
    public keyword = '';
    public filter = 'all';
    public page = 1;
    public selected = '';
    public loading = true;
    public loaded = false;
    public error = '';
    public syncJob: any = null;
    public filters = [{id:'all', label:'전체'}, {id:'ner', label:'NER 재추출 반영'}, {id:'indexed', label:'태그 있음'}, {id:'tagless', label:'태그 없음'}, {id:'mixed', label:'혼합'}, {id:'unstarted', label:'자료 준비 필요'}, {id:'error', label:'분석 확인 필요'}];
    private timer: any = null;
    private restoreCleanup = () => {};
    private epoch = 0;
    private destroyed = false;
    private pop = () => { this.readLocation(); void this.service.render(); };
    constructor(@Inject( Service) public service: Service) { }
    private readLocation() {
        const p = new URLSearchParams(location.search);
        this.keyword = p.get('q') || '';
        this.filter = this.filters.some(f => f.id === p.get('filter')) ? p.get('filter')! : 'all';
        const page = Number(p.get('page'));
        this.page = Number.isSafeInteger(page) && page > 0 ? page : 1;
        this.selected = p.get('project') || '';
        if (this.loaded) this.page = Math.min(this.page, this.pageCount());
    }
    async ngOnInit() {
        this.readLocation();
        window.addEventListener('popstate', this.pop);
        await this.service.init();
        if (this.destroyed) return;
        let moved = false;
        const watch = (event: Event) => { if (event.target !== document.body && event.target !== document.documentElement) moved = true; };
        document.addEventListener('focusin',watch);
        this.restoreCleanup = () => document.removeEventListener('focusin',watch);
        try {
            await this.reload();
            if (!this.destroyed && !moved && this.selected && (!document.activeElement || document.activeElement === document.body || document.activeElement === document.documentElement)) document.getElementById('review-project-'+this.selected)?.focus();
        } finally { document.removeEventListener('focusin',watch); }
        if (this.destroyed) return;
        this.timer = window.setInterval(() => { if (this.hasRunning()) void this.reload(false); }, 3000);
    }
    ngOnDestroy() { this.destroyed = true; this.epoch++; clearInterval(this.timer); this.restoreCleanup(); window.removeEventListener('popstate', this.pop); }
    async reload(showLoading = true) {
        const epoch = ++this.epoch;
        if (showLoading) this.loading = true;
        this.error = '';
        try {
            const data = await EntityApi.request('overview');
            if (this.destroyed || epoch !== this.epoch) return;
            this.projects = data.projects; this.unresolved = data.unresolved_sources;
            this.syncJob = data.sync_job; this.loaded = true;
            this.page = Math.min(this.page, this.pageCount());
            window.dispatchEvent(new Event('reviewops:entity-updated'));
        } catch (error: any) { if (!this.destroyed && epoch === this.epoch) this.error = error.message; }
        finally { if (!this.destroyed && epoch === this.epoch) { this.loading = false; await this.service.render(); } }
    }
    hasRunning() { return ['running','queued'].includes(this.syncJob?.status) || this.projects.some(p => ['running','queued'].includes(p.extraction_status)); }
    matches(p: any) {
        return this.filter === 'all' || (this.filter === 'ner' ? p.ner_document_count > 0 : this.filter === 'mixed' ? p.tag_state === 'mixed' : this.filter === 'indexed' ? (p.tagged_source_count ?? (p.index_count > 0 ? 1 : 0)) > 0 : this.filter === 'tagless' ? (p.tagless_source_count ?? (p.active_run && !p.index_count ? 1 : 0)) > 0 : this.filter === 'unstarted' ? !p.active_run : ['failed','interrupted'].includes(p.extraction_status));
    }
    filtered() {
        const q = this.keyword.trim().toLowerCase();
        return this.projects.filter(p => (!q || [p.name,p.item_id].some(v => String(v || '').toLowerCase().includes(q))) && this.matches(p));
    }
    paged() { return this.filtered().slice((this.page-1)*10,this.page*10); }
    pageCount() { return Math.max(1,Math.ceil(this.filtered().length/10)); }
    pageNumbers(limit = 5) {
        const count = this.pageCount();
        const start = Math.max(1,Math.min(this.page-Math.floor(limit/2),count-limit+1));
        return Array.from({length:Math.min(limit,count)},(_,i) => start+i);
    }
    listUrl(project = this.selected) {
        const p = new URLSearchParams();
        if (this.keyword) p.set('q',this.keyword);
        if (this.filter !== 'all') p.set('filter',this.filter);
        if (this.page > 1) p.set('page',String(this.page));
        if (project) p.set('project',project);
        return '/entity-reviews' + (p.size ? '?' + p : '');
    }
    private remember() {
        const url = this.listUrl();
        history.replaceState(history.state,'',url);
        try { sessionStorage.setItem('entity-reviews:return',url); } catch { }
    }
    follow(event: MouseEvent, project: any) {
        const selection = window.getSelection?.();
        if (selection?.toString() && (event.currentTarget as HTMLElement)?.contains(selection.anchorNode)) { event.preventDefault(); return; }
        this.selected = project.item_id; this.remember();
    }
    async reset() { this.page = 1; this.selected = ''; this.remember(); await this.service.render(); }
    clearKeyword() {
        this.keyword = '';
        const search = document.getElementById('reviews-search') as HTMLInputElement | null;
        if (!this.destroyed && search?.isConnected && !search.disabled) search.focus({preventScroll:true});
        return this.reset();
    }
    async clear() { this.keyword = ''; this.filter = 'all'; await this.reset(); document.getElementById('reviews-search')?.focus(); }
    async setFilter(filter: string) { this.filter = filter; await this.reset(); }
    async setPage(page: number) {
        this.page = Math.max(1,Math.min(page,this.pageCount())); this.selected = ''; this.remember();
        const active = document.activeElement; await this.service.render();
        if (!this.destroyed && document.activeElement === active) document.getElementById('reviews-results')?.focus();
    }
    reviewHref(p: any) { return this.url(p)+'?'+new URLSearchParams({returnTo:this.listUrl(p.item_id)}); }
    url(p: any) { return '/entity-reviews/' + encodeURIComponent(p.item_id); }
    tagLabel(state: string) { return ({present:'태그 있음',absent:'태그 없음',mixed:'혼합',partial:'일부 확인 전'} as any)[state] || '태그 확인 전'; }
    status(p: any) {
        const labels: any = {queued:'개체명 분석 대기',running:'개체명 분석 중',failed:'분석 실패 · 확인 필요',interrupted:'분석 중단 · 확인 필요',outdated:'원본 변경 · 이전 결과'};
        return labels[p.extraction_status] || (p.ner_document_count ? 'NER 재추출 반영' : !p.active_run ? '자료 준비 필요' : p.index_count ? '기존 태그 있음' : '기존 태그 없음 · 본문 확인');
    }
    progress(p: any) {
        if (!p.active_run) return '자료 준비 후 확인';
        if (!p.review_target_count) return '검수 대상 자료 없음';
        return '완료 ' + Number(p.reviewed_count).toLocaleString() + ' / 대상 ' + Number(p.review_target_count).toLocaleString() + '개 자료';
    }
    task(p: any) { return !p.active_run ? '자료 준비 상태를 확인하세요.' : p.ner_count || p.index_count ? '자료를 고르고 원문과 후보를 대조하세요.' : '본문을 읽고 빠진 개체명이 있는지 확인하세요.'; }
    total(key: string) { return this.projects.reduce((n,p) => n+Number(p[key] || 0),0); }
}

export default PageEntityReviewsComponent;